import { render } from "./toLoginTemp.vue?vue&type=template&id=28d1033c&scoped=true"
import script from "./toLoginTemp.vue?vue&type=script&lang=js"
export * from "./toLoginTemp.vue?vue&type=script&lang=js"

import "./toLoginTemp.vue?vue&type=style&index=0&id=28d1033c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d1033c"]])

export default __exports__